module.exports = __webpack_public_path__ + "766c39e12c048ee8230c17bc6cdf8849.woff2";